import React from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { postRequest, showHideLoader } from "../Redux/Actions/SharedActions";
import Toast from "./Shared/Toasts/Toast";
import { homeIcon, yourLoanIcon, arrangementsIcon, loanRepaymentIcon, reborrowIcon, paymentMethodIcon, notificationIcon, card, goldMemberstatusIcon, referralProgramIcon } from "./icons";
const Sidebar = (props) => {
  const { yourLoansReducer, dispatch, profile } = props;

  const { company, personal } = profile;

  const { loanNo } = yourLoansReducer.loanTransactionModel.loanDetails;

  function myFunction() {
    var element = document.getElementById("root");
    element.classList.toggle("nav-open");
    element = document.getElementById("menu-btn");
    element.classList.toggle("active");
    element = document.getElementById("menu-open");
    element.classList.toggle("open");
  }

  const loader = (check) => {
    dispatch(showHideLoader(check));
  };

  const sendEmail = () => {
    dispatch(
      postRequest(
        "api/Customer/SendEmail",
        {
          to: "creditcontrol@cubefunder.com",
          ccList: null,
          subject: `Statement Request App ID: ${loanNo}`,
          body: `${personal.fname} ${personal.lname} (${company.company_name}, Registration No: ${company.reg_no}) has requested for a statement against Application ID ${loanNo}.`,
        },
        loader,
        (res) => {
          Toast.success("Statement request sent successfully");
        },
        (res) => {
          Toast.error("Statement request could not be sent");
        }
      )
    );
  };

  return (
    <section>
      <div className="main-wrapper section">
        <div className="left-wrapper">
          <div className="nav-main" id="menu-open">
            <ul className={"navigation"}>
              <li
                onClick={() => {
                  sessionStorage.removeItem("user_from");
                }}
              >
                {/* <NavLink exact to={'/'} > */}
                <a href={"/"}>
                  <i>
                    {homeIcon()}
                  </i>
                  <span>Home</span>
                </a>
                {/* </NavLink> */}
              </li>
              <li>
                <NavLink to={"/YourLoans"} onClick={() => myFunction()}>
                  <i>
                    {yourLoanIcon()}
                  </i>
                  <span>Your Loans</span>
                </NavLink>
                {window.location.pathname === "/YourLoans" && (
                  <ul className={"sub-menu"}>
                    <li>
                      <span onClick={() => sendEmail()}>Request Statement</span>
                    </li>
                  </ul>
                )}
              </li>
              <li>
                <NavLink to={"/arrangements"} onClick={() => myFunction()}>
                  <i>
                    {arrangementsIcon()}

                  </i>

                  <span>Arrangements</span>
                </NavLink>
              </li>
              <li>
                <NavLink to={"/PaymentGateway"} onClick={() => myFunction()}>
                  {/* <a onClick={() => myFunction()}> */}
                  <i>
                    {paymentMethodIcon()}
                  </i>

                  <span>Make a Loan Repayment</span>
                </NavLink>
              </li>


              <li>
                <NavLink to={"/ReBorrow"} onClick={() => myFunction()}>
                  <i>
                    {reborrowIcon()}
                  </i>
                  <span>Apply to re-borrow</span>
                </NavLink>
              </li>
              <li>
                <NavLink to={"/PaymentDetails"} onClick={() => myFunction()}>
                  <i>
                    {paymentMethodIcon()}
                  </i>
                  <span>Set Up A New Payment Method</span>
                </NavLink>
              </li>

              <li>
                <NavLink to={"/notifications"} onClick={() => myFunction()}>
                  <i>
                    {notificationIcon()}

                  </i>

                  <span>Notifications</span>
                </NavLink>
              </li>
              <li>
                <NavLink to={"/Referral"} onClick={() => myFunction()}>
                  <i> {referralProgramIcon()} </i>
                  <span>Referral Program</span>
                </NavLink>
              </li>
              <li>
                <NavLink to={"/goldMemberstatus"} onClick={() => myFunction()}>
                  <i> {goldMemberstatusIcon()} </i>
                  <span>Gold Member Status</span>
                </NavLink>
              </li>
              {/* <li>
                <NavLink to={"/card"} onClick={() => myFunction()}>
                  <i>
                    {card()}
                  </i>

                  <span>Cubefunder Black Card</span>
                </NavLink>
              </li> */}
            </ul>
          </div>

          <div className="mobile nav-menu">
            <ul>
              <li>
                <NavLink to={"/YourLoans"}>
                  <i>
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="18px"
                      height="24px"
                      viewBox="0 0 18 24"
                      enableBackground="new 0 0 18 24"
                      xmlSpace="preserve"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.22,0h9.97c0.54,0,1.06,0.21,1.47,0.6l3.59,3.39
											C17.73,4.44,18,5.08,18,5.76v15.88c0,1.3-0.99,2.36-2.22,2.36H2.22C0.99,24,0,22.94,0,21.64V2.36C0,1.06,0.99,0,2.22,0z M2,19v3h14
											v-3H2z M2,17h14V5.76l-4-4.15V7h2.65c0.62,0,0.56,0.02,0.56,0.67S14.71,9,14.1,9h-2.99C10.5,9,10,8.47,10,7.82V2H2V17z"
                      />
                    </svg>
                  </i>
                  <span>Your Loans</span>
                </NavLink>
              </li>

              <li>
                {window.location.pathname === "/YourLoans" ? (
                  <NavLink to={"PaymentGateway"}>
                    <i>
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="22px"
                        height="16px"
                        viewBox="0 0 22 16"
                        enableBackground="new 0 0 22 16"
                        xmlSpace="preserve"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M18,3c0.55,0,1,0.45,1,1s-0.45,1-1,1h-2c-0.55,0-1-0.45-1-1
                s0.45-1,1-1H18z M6,11c0.55,0,1,0.45,1,1s-0.45,1-1,1H4c-0.55,0-1-0.45-1-1s0.45-1,1-1H6z M11,11c-1.66,0-3-1.34-3-3s1.34-3,3-3
                s3,1.34,3,3S12.66,11,11,11z M11,9c0.55,0,1-0.45,1-1s-0.45-1-1-1s-1,0.45-1,1S10.45,9,11,9z M2,2v12h18V2H2z M2,0h18
                c1.1,0,2,0.9,2,2v12c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z"
                        />
                      </svg>
                    </i>{" "}
                    <span>Make A Payment</span>
                  </NavLink>
                ) : (
                  <NavLink to={"/Contact"}>
                    <i>
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="22px"
                        height="16px"
                        viewBox="0 0 22 16"
                        enableBackground="new 0 0 22 16"
                        xmlSpace="preserve"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M18,3c0.55,0,1,0.45,1,1s-0.45,1-1,1h-2c-0.55,0-1-0.45-1-1
										s0.45-1,1-1H18z M6,11c0.55,0,1,0.45,1,1s-0.45,1-1,1H4c-0.55,0-1-0.45-1-1s0.45-1,1-1H6z M11,11c-1.66,0-3-1.34-3-3s1.34-3,3-3
										s3,1.34,3,3S12.66,11,11,11z M11,9c0.55,0,1-0.45,1-1s-0.45-1-1-1s-1,0.45-1,1S10.45,9,11,9z M2,2v12h18V2H2z M2,0h18
										c1.1,0,2,0.9,2,2v12c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z"
                        />
                      </svg>
                    </i>
                    <span>Contact Us</span>
                  </NavLink>
                )}
              </li>
              <li>
                {window.location.pathname === "/YourLoans" ? (
                  <NavLink to={"/Reborrow"}>
                    <i>
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="21px"
                        height="25px"
                        viewBox="0 0 21 25"
                        enableBackground="new 0 0 21 25"
                        xmlSpace="preserve"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M16.17,1.14l-0.45-0.46c-0.9-0.9-2.35-0.9-3.26-0.01l-0.43,0.42
										l-0.36-0.37C10.8-0.19,9.38-0.24,8.45,0.61L7.92,1.09l-0.26-0.3C6.75-0.24,5.17-0.26,4.23,0.74L3.9,1.09l0.03-0.44
										C2.44-0.77,0,0.3,0,2.37v20.27C0,23.94,1.04,25,2.33,25h16.34c1.29,0,2.33-1.06,2.33-2.36V2.37C21,1.06,19.96,0,18.67,0
										C17.82,0,16.58,0.46,16.17,1.14z M19,19v2v2H2v-2v-2v-2v-1V1.37l2.15,2.05l1.77-2.05l1.81,2.05L10,1.37l1.98,2.05l2.1-2.05
										l2.07,2.05L19,1.64V16v1V19z"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M11.75,15v-2H9.03l-0.08-2.16c0-0.59,0.13-1.06,0.38-1.37
										C9.58,9.16,9.91,9,10.3,9c0.47,0,0.84,0.16,1.09,0.47c0.25,0.31,0.39,0.75,0.39,1.31h2.52c0-1.16-0.36-2.06-1.07-2.75
										C12.52,7.34,11.55,7,10.31,7c-1.22,0-2.2,0.36-2.92,1.06c-0.72,0.72-1.08,1.67-1.08,2.89L6.38,13H5.03v2h1.42l0.05,1.39
										c0,0.97-0.22,1.52-0.64,1.61H5.05v2h9.31v-2H8.63c0.35-0.44,0.54-1.02,0.54-1.75L9.11,15H11.75z"
                        />
                      </svg>
                    </i>
                    <span>ReBorrow</span>
                  </NavLink>
                ) : (
                  <NavLink to={"/PersonalDetails"}>
                    <i>
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="18.004px"
                        height="21px"
                        viewBox="0 0 18.004 21"
                        enableBackground="new 0 0 18.004 21"
                        xmlSpace="preserve"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M2,20.02C1.99,20.57,1.53,21.01,0.98,21S-0.01,20.53,0,19.98
										C0.15,13.46,3.22,11,9,11c6.05,0,9.14,2.48,9,9.02c-0.02,0.55-0.47,0.99-1.03,0.98c-0.55-0.01-0.99-0.47-0.97-1.02
										C16.12,14.52,13.88,13,9,13C4.38,13,2.12,14.54,2,20.02z M9,8c1.66,0,3-1.34,3-3s-1.34-3-3-3S6,3.34,6,5S7.34,8,9,8z M9,10
										c-2.76,0-5-2.24-5-5s2.24-5,5-5s5,2.24,5,5S11.76,10,9,10z"
                        />
                      </svg>
                    </i>
                    <span>Personal</span>
                  </NavLink>
                )}
              </li>
              <li>
                <span
                  onClick={() => myFunction()}
                  id="menu-btn"
                  className="nav-toggle"
                >
                  <i>
                    <span className="menu Top" />
                    <span className="menu Middle" />
                    <span className="menu Bottom" />
                  </i>
                  <span style={{ marginTop: "-20px" }}>Menu</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
const mapStateToProps = (store) => {
  return {
    yourLoansReducer: store.LoanDetailsReducer,
    profile: store.profileReducer,
  };
};
export default connect(mapStateToProps)(withRouter(Sidebar));
